import script from "./SiderDetail2.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiderDetail2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__